import { Fragment, ReactNode, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllActions } from "../../API/Actions/actionService";
import { Action } from "../../data/types";
import backgroundImage from "../../images/background2.png";

import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselPreviousWithDots,
} from "../ui/carousel";

type Props = {
  children?: ReactNode;
};

const ActionHomeSection = (props: Props) => {
  const [actions, setActions] = useState<Action[]>([]);
  const fetchData = async () => {
    const response = await getAllActions();
    setActions(response?.actions);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Fragment>
      <div
        className="relative flex items-center justify-center h-full p-4 mt-8 md:p-24"
        style={{
          zIndex: 0,
        }}
      >
        <div
          className="absolute inset-0 bg-cover "
          style={{
            backgroundImage: `linear-gradient(rgba(22, 152,117, 0.5), rgba(22, 152,117, 0.5)), url(${backgroundImage})`,
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            //opacity: "50%",
            zIndex: -1,
          }}
        ></div>
        <div className="container">
          <div className="text-center">
            <div className="text-3xl font-bold text-white">Hydreaulys s’engage </div>
          </div>
          <div className="flex flex-col justify-center mt-4 space-x-16 md:mt-20 lg:flex-row">
            <div className="mt-1 sm:mr-0 lg:mr-10 lg:w-1/4">
              <p className="mt-4 text-justify text-white">
                Le syndicat Hydreaulys se positionne comme un acteur public
                incontournable de l’ouest parisien, engagé en faveur du
                développement durable. Il agit pour préserver la ressource en
                eau, promouvoir l’économie circulaire et garantir un service
                public accessible et maîtrisé. <br/>
                Grâce à des initiatives
                innovantes, Hydreaulys allie traitement des eaux usées,
                production d’énergies renouvelables et protection des
                écosystèmes locaux.
              </p>
            </div>
            <div className="flex justify-center mt-2 space-x-3 lg:w-1/2">
              <Carousel
                opts={{ align: "start" }}
                className="w-full"
                cardContentData={actions}
              >
                <CarouselContent>
                  {actions.map((_, index) => (
                    <CarouselItem key={index}>
                      <div className="flex p-1 space-x-5">
                        {[
                          actions[index],
                          actions[(index + 1) % actions.length],
                        ].map((card) => {
                          const imageUrl =
                            typeof card.image === "string" &&
                            card.image.trim() !== ""
                              ? `https://hydreaulys.fr/uploads/hydreaulys/initiatives/${card.image}`
                              : null;
                          return (
                            <Card key={card.id} className="w-full">
                              <CardHeader>
                                <CardTitle className="p-4">
                                  {imageUrl && (
                                    <img
                                      src={imageUrl}
                                      alt={card.title}
                                      className="  w-full h-[200px]"
                                    />
                                  )}
                                </CardTitle>
                              </CardHeader>
                              <CardContent className="h-40 overflow-hidden">
                                <p className="font-bold">{card.title}</p>
                                <p>
  {card.description.replace(/<[^>]+>/g, '').length > 100
    ? card.description.replace(/<[^>]+>/g, '').substring(0, 100) + "..."
    : card.description.replace(/<[^>]+>/g, '')}
</p>
                              </CardContent>
                              <CardFooter className="flex items-center justify-center w-full">
                                <Link
                                  to={`/initiatives/${card.slug}`}
                                  className="w-full sm:mt-10"
                                >
                                  <Button className="w-full sm:mt-10">
                                    Voir plus
                                  </Button>
                                </Link>
                              </CardFooter>
                            </Card>
                          );
                        })}
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPreviousWithDots cardContentData={actions} />
                <CarouselPrevious className="text-white bg-primary border-none" />
                <CarouselNext className="text-white bg-primary border-none" />
              </Carousel>
            </div>
          </div>
          <div className="flex justify-center">
            <Button className="w-1/5">
              {" "}
              <Link to="/engagements">Voir plus</Link>
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ActionHomeSection;
